import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { ScreeningMockPanel } from '../ui/ScreeningMockPanel';
import { CloseIcon } from '../../assets/icons';

interface DemoModalProps {
  open: boolean;
  onClose: () => void;
}

export const DemoModal: React.FC<DemoModalProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'var(--bg-1)',
          backgroundImage: 'none',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid rgba(255,255,255,0.1)',
          minHeight: '600px',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
          padding: '1.5rem 2rem',
        }}
      >
        <div>
          <h2 className="text-2xl font-semibold text-white mb-1">Rapport de Screening</h2>
          <p className="text-sm text-white/50">Exemple • Données fictives</p>
        </div>
        <IconButton
          onClick={onClose}
          sx={{
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.1)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          padding: '3rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="w-full">
          <ScreeningMockPanel />
        </div>
      </DialogContent>
    </Dialog>
  );
};
